import { defineMessages, useIntl } from "react-intl";

import {
  queryClient,
  MutationActions,
  QueryKeys,
  useEntityMutation,
} from "@/api/core";
import { useApi } from "@/hooks";
import { statusSchema } from "@/schemas";
import toast from "@/toast";

import { updateStatusCache } from "../utils";

const messages = defineMessages({
  deletedTruth: {
    id: "status.error.deletedTruth",
    defaultMessage: "This Truth has been deleted and is no longer available.",
  },
});

interface Variables {
  id: string;
}

function useUnfavouriteStatus() {
  const intl = useIntl();
  const api = useApi();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    idAttributeFromVariables: "id",
    action: MutationActions.UPDATE,
    schema: statusSchema,
    skipOnSuccess: true, // TODO: Remove once API added optimistic updates.
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/statuses/${variables.id}/unfavourite`),
    onMutate(variables) {
      const [prevStatus] = updateStatusCache(variables.id, (prevStatus) => ({
        favourited: false,
        favourites_count: prevStatus.favourites_count - 1,
      }));

      return { prevStatus };
    },
    onError(error, variables, context) {
      if (error.response?.status === 404) {
        toast.error(intl.formatMessage(messages.deletedTruth));
      }
      if (context) {
        queryClient.setQueryData(
          QueryKeys.statuses.detail(variables.id),
          context.prevStatus,
        );
      }
    },
  });
}

export { useUnfavouriteStatus };
